import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "nc_admin_token";
const EMAIL_KEY = "nc_admin_email";

export const authApi = axios.create({ baseURL: API });

authApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

authApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(EMAIL_KEY);
      if (!window.location.pathname.endsWith("/admincontrol/login")) {
        window.location.href = "/admincontrol/login";
      }
    }
    return Promise.reject(err);
  }
);

export const auth = {
  async login(email, password) {
    const { data } = await authApi.post("/admin/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem(EMAIL_KEY, data.email);
    return data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
  },
  isAuthed() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
  email() {
    return localStorage.getItem(EMAIL_KEY);
  },
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
